<template>
  <div>
    <v-card class="pl-5 pr-5">
      <h1>User Collection</h1>
      <v-divider></v-divider>
      <Notification :notify="notify" />
    </v-card>
  </div>
</template>

<script>
import Notification from "@/components/Notification";
import * as api from "@/api";

export default {
  name: "UserCollection",
  components: {
    Notification,
  }
}
</script>
<style scoped>
.icon-edit {
  color: #1975d2;
}
.icon-delete {
  color: red;
}
.col {
  padding: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/UserCollection.vue